export default __webpack_public_path__ + "static/char-thumb-04-339f3af200166e3c782c94b7b26735bc.png";